const PHRASE = "Little dogs · Big inspiration · ";

export const Marquee = () => (
  <div
    aria-hidden
    data-testid="marquee"
    className="select-none overflow-hidden py-12 sm:py-16"
  >
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((copy) => (
        <span
          key={copy}
          className="pr-2 font-serif text-[44px] font-medium italic leading-none text-ink/[0.12] sm:text-6xl lg:text-7xl"
        >
          {PHRASE.repeat(5)}
        </span>
      ))}
    </div>
  </div>
);
